import React, { useState } from 'react';
import { MapPin, Mail, Globe, Clock } from 'lucide-react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <div className="contact-page">
      {/* Outer Luxury Frame Container */}
      <div className="luxury-wrapper">
        {/* Top Header Label */}
        <div className="gold-header-banner">
          BAYT AL-KHAYR ◆ EST. 2026 ◆ MEDINA
        </div>

        {/* Main Title Section */}
        <div className="contact-hero-title">
          <h1>Contact Us</h1>
          <p className="subtitle">We'd love to hear from you, Every Product</p>
          <p className="tagline">A Piece of Khayr for Your Home.</p>
        </div>

        {/* Two-Column Grid Container */}
        <div className="contact-grid">
          {/* Left Frame: Contact Form */}
          <div className="ornate-card form-card">
            <div className="corner-decor top-left"></div>
            <div className="corner-decor top-right"></div>
            <div className="corner-decor bottom-left"></div>
            <div className="corner-decor bottom-right"></div>

            <h2 className="card-title">
              <span className="decor-line">✦</span> Contact Form <span className="decor-line">✦</span>
            </h2>

            <form onSubmit={handleSubmit} className="ornate-form">
              <div className="input-group">
                <label>✦ Name ✦</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Your full name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="input-group">
                <label>✦ Email ✦</label>
                <input
                  type="email"
                  name="email"
                  placeholder="your.email@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="input-group">
                <label>✦ Message ✦</label>
                <textarea
                  name="message"
                  placeholder="Write your message here..."
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="gold-submit-btn">
                Send Message
              </button>
            </form>
          </div>

          {/* Right Frame: Location & Contact Info */}
          <div className="ornate-card info-card">
            <div className="corner-decor top-left"></div>
            <div className="corner-decor top-right"></div>
            <div className="corner-decor bottom-left"></div>
            <div className="corner-decor bottom-right"></div>

            <div className="info-list">
              <div className="info-row">
                <div className="info-icon"><MapPin size={22} /></div>
                <div className="info-text">
                  <h3>Our Location</h3>
                  <p>Medina, Saudi Arabia</p>
                </div>
              </div>

              <div className="info-row">
                <div className="info-icon"><Mail size={22} /></div>
                <div className="info-text">
                  <h3>Email</h3>
                  <p>info@baytal-khayr.com</p>
                </div>
              </div>

              <div className="info-row">
                <div className="info-icon"><Globe size={22} /></div>
                <div className="info-text">
                  <h3>Global Shipping</h3>
                  <p>60+ countries worldwide</p>
                </div>
              </div>

              <div className="info-row">
                <div className="info-icon"><Clock size={22} /></div>
                <div className="info-text">
                  <h3>Hours</h3>
                  <p>Saturday – Thursday: 9:00 AM – 6:00 PM</p>
                  <p className="sub-hours">Friday: Closed</p>
                </div>
              </div>
            </div>

            {/* Map Vector Graphic */}
            <div className="map-footer">
              <span className="serving-label">Serving Customers Worldwide</span>
              <svg className="world-map-svg" viewBox="0 0 1000 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M150,120 Q180,100 220,130 T280,150 T310,210 T250,250 T180,220 Z" fill="rgba(212,175,55,0.25)" stroke="#d4af37" strokeWidth="1.5" />
                <path d="M450,100 Q500,80 580,110 T620,180 T550,220 T480,160 Z" fill="rgba(212,175,55,0.25)" stroke="#d4af37" strokeWidth="1.5" />
                <path d="M480,240 Q530,220 580,260 T560,380 T500,400 T460,310 Z" fill="rgba(212,175,55,0.25)" stroke="#d4af37" strokeWidth="1.5" />
                <path d="M650,80 Q750,60 880,100 T920,220 T800,280 T680,180 Z" fill="rgba(212,175,55,0.25)" stroke="#d4af37" strokeWidth="1.5" />
                <path d="M780,320 Q840,300 900,340 T880,420 T810,410 Z" fill="rgba(212,175,55,0.25)" stroke="#d4af37" strokeWidth="1.5" />
              </svg>
            </div>
          </div>
        </div>

        {/* Footer Sub-banner */}
        <div className="gold-footer-banner">
          Bayt Al-Khayr 2026 • Medina • Serving World Globally • Halal • Ethical • Global • no Shopify
        </div>
      </div>
    </div>
  );
}

export default Contact;
